import queryString from "query-string";

export interface Musician {
  name: string;
  link: string;
}

export function getMusicianLink(musician: Musician) {
  const [path, query] = musician.link.split("?");
  const parsedQuery = queryString.parse(query);

  return queryString.stringifyUrl({
    url: path,
    query: {
      ...parsedQuery,
      ref: "bedroom-producer",
    },
  });
}
